import { useEffect, useMemo, useState } from "react";
import "./index.scss";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import Message from "../../storybook/Message";
import { checkDirectDebitHealth } from "../../api";
import { saveActualFrequencyFromDropDown, saveDirectDebitRefeneceId } from "../../ducks/redux/actions/FinancialReferral";


const WEB_COMPONENT_URL = process.env.REACT_APP_WEB_COMPONENT_URL;

const DirectDebitForm = () => {
  const dispatch = useDispatch()
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { t } = useTranslation();
  const accountNo = useSelector((state: any) => state.userChoicesReducer?.accountnumber);
  const startDate = useSelector((state: any) => state.userChoicesReducer?.directDebitStartDate);
  const frequency = useSelector((state: any) => state.userChoicesReducer?.directDebitFrequency);
  const directDebitAmount = useSelector((state: any) => state.userChoicesReducer?.directDebitAmount);
  const publishableKeyValue = useSelector((state: any) => state.userChoicesReducer?.publishableKeyValue)?? 'peabodykey1';
  const instructionReferenceValue = useSelector((state: any) => state.userChoicesReducer?.instructionReferenceValue);

   const instructionReferenceWithUuid = useMemo(() => {
    const uid = globalThis.crypto?.randomUUID?.();
    return `${instructionReferenceValue}_${uid}`.slice(0, 50);
  }, [instructionReferenceValue]);
  dispatch(saveDirectDebitRefeneceId(instructionReferenceWithUuid))

  const handleReturnHome = () => {
    globalThis.location.assign("/customer360View");
  };

  const frequencyMap: { [key: string]: { interval: string; unit: string } } = {
    '1': { interval: '1', unit: 'Week' },   // Weekly
    '2': { interval: '2', unit: 'Week' },   // Fortnightly (2 weeks)
    '3': { interval: '4', unit: 'Week' },   // 4-weekly
    '4': { interval: '1', unit: 'Month' }   // Monthly
  };

  const frequencyConfig = frequencyMap[frequency as string] || { interval: '1', unit: 'Month' };
  const scheduleInterval = frequencyConfig.interval;
  const frequencyCal = frequencyConfig.unit;

const getFrequencyLabel = (unit: string, interval: string): string => {
  if (unit === "Week" && interval === "1") return "Weekly";
  if (unit === "Week" && interval === "2") return "Fortnightly";
  if (unit === "Week" && interval === "4") return "4 Weekly";
  if (unit === "Month" && interval === "1") return "Monthly";
  return "";
};

  const scheduleFrequencyLabel =  getFrequencyLabel(frequencyCal, scheduleInterval);
  dispatch(saveActualFrequencyFromDropDown(scheduleFrequencyLabel))

  useEffect(() => {
    let script: HTMLScriptElement | undefined;
    const controller = new AbortController();

    const loadWidget = async () => {
      try {
        // Prevent duplicate script load
        if (customElements.get("ipdd-orchestration-form")) {
          setIsLoaded(true);
          return;
        }

        const healthResponse = await checkDirectDebitHealth();

        if (healthResponse?.status.toLowerCase() !== "healthy") {
          throw new Error(`Healthcheck failed: ${healthResponse.status}`);
        }
        localStorage.setItem('dd_api_called', 'false');
        script = document.createElement("script");
        script.src = `${WEB_COMPONENT_URL}?v=${Date.now()}`;

        script.onload = () => {
          setIsLoaded(true);
        };

        script.onerror = () => {
          console.error("Failed to load web component script");
          setHasError(true);
        };

        document.head.appendChild(script);
      } catch (error) {
        if ((error as Error).name !== "AbortError") {
          console.error("Healthcheck/script load failed", error);
          setHasError(true);
        }
      }
    };

    loadWidget();

    return () => {
      controller.abort();
      if (script) {
        script.remove();
      }
    };
  }, []);

  
  if (hasError) {
    return (
        <Message className="error-msg">{t("Paypoint_Widget_Load_Error")} 
         <button type= {undefined} onKeyDown={handleReturnHome} onClick={handleReturnHome} 
            className="underline cursor-pointer return-btn">{t("Return_to_Home")}
          </button>
        </Message>
    );
  }

  if (!isLoaded) return <div>Loading Direct Debit Form...</div>;

  return (
      <div className="DD_mt">
        <ipdd-orchestration-form
          instructionreference={instructionReferenceWithUuid}
          customeraccountid={accountNo}
          schedulestartdate={startDate}
          scheduleenddate= ''
          scheduleamount={directDebitAmount}
          scheduleintervalunit={frequencyCal}
          scheduleinterval={scheduleInterval}
          adhoc='false'
          publishablekey={publishableKeyValue}
        />
      </div>
  );
};

export default DirectDebitForm;
